export const draft = Object.freeze({
  id: 1,
  name: 'Borrador',
  color: '#B5C3BC',
});

export const completed = Object.freeze({
  id: 2,
  name: 'Completado',
  color: '#A3E5B3',
});

export const pendingSignature = Object.freeze({
  id: 3,
  name: 'Pendiente de Firma',
  color: '#FAE76F',
});

export const rejectedSignature = Object.freeze({
  id: 4,
  name: 'Firma Rechazada',
  color: '#F5A623',
});

export const canceledDocument = Object.freeze({
  id: 5,
  name: 'Documento Cancelado',
  color: '#D9534F',
});

const data = Object.freeze({
  Draft: draft.id,
  Completed: completed.id,
  PendingSignature: pendingSignature.id,
  RejectedSignature: rejectedSignature.id,
  CanceledDocument: canceledDocument.id,
});

export default data;
